/* @sravni/react-design-system version 0.2.65 */
import { __rest, __read, __assign } from 'tslib';
import * as React from 'react';
import { useStyles, safeInvoke } from '@sravni/react-utils';
import '../../Space/index.js';
import modules_ef1f9f15 from '../styles/Tabs.module.less.js';
import Space from '../../Space/src/Space.js';

/**
 * @description Use Tabs to organize your content in logical groupings
 *
 * @component
 * @example
 * ```jsx
 * <Tabs activeKey="tab-key">
 *   <Tabs.TabPane key="tab-key" title="Tab">tab content</Tabs.TabPane>
 * </Tabs>
 * ```
 */
var Tabs = React.forwardRef(function (props, ref) {
    var _a = props.defaultIndex, defaultIndex = _a === void 0 ? 0 : _a, _b = props.color, color = _b === void 0 ? 'gray' : _b, className = props.className, children = props.children, onChange = props.onChange, restProps = __rest(props, ["defaultIndex", "color", "className", "children", "onChange"]);
    var _c = __read(React.useState(defaultIndex), 2), innerValue = _c[0], setInnerValue = _c[1];
    var cx = useStyles(modules_ef1f9f15);
    var handleChangeActiveTab = React.useCallback(function (event) {
        var value = Number(event.currentTarget.dataset.index);
        setInnerValue(value);
        safeInvoke(onChange, value);
    }, [onChange]);
    var navigation = React.useMemo(function () {
        return React.Children.map(children, function (child, index) {
            var _a;
            var classNames = cx('tab', (_a = {
                    active: index === innerValue
                },
                _a["color-" + color] = true,
                _a));
            return (React.createElement(Space, { "data-qa": "Tab", size: 4, align: "center", inline: true, className: classNames, "data-index": index, onClick: handleChangeActiveTab }, child.props.title));
        });
    }, [innerValue, color, children, handleChangeActiveTab]);
    var panes = React.useMemo(function () {
        return React.Children.map(children, function (child, index) {
            var classNames = cx(child.props.className, 'pane', {
                active: index === innerValue,
            });
            // return <div {...child.props} className={classNames}>{child.props.children}</div>
            return React.cloneElement(child, __assign(__assign({}, child.props), { className: classNames }));
        });
    }, [innerValue, children]);
    return (React.createElement("div", __assign({ ref: ref, "data-qa": "Tabs", className: className }, restProps),
        React.createElement(Space, { size: 12, align: "center", className: cx('tabs') }, navigation),
        React.createElement("div", { className: cx('panes') }, panes)));
});
Tabs.defaultProps = {
    color: 'gray',
    defaultIndex: 0,
};
Tabs.displayName = 'Tabs';

export default Tabs;
//# sourceMappingURL=Tabs.js.map
